import React from 'react';
// @ts-ignore
import { FormattedHTMLMessage, injectIntl } from 'react-intl';
import {
    FieldLabel,
    FormSelectChoice,
    getSafe,
    InputSelectComponentProps,
} from '@sheerid/jslib';
import { InputSelectComponent } from '../../FormInputs/InputSelect/InputSelectComponent';

export const Country = ({
    value,
    isErrored,
    options,
    onChange,
    onKeyDown,
    intl,
    placeholder = '',
    isRequired = false,
}: InputSelectComponentProps) => {
    const inputId = 'sid-country';
    const [floatLabel, setFloatLabel] = React.useState(getSafe(() => !!value.name.length, true));
    const [focus, setFocus] = React.useState(false);

    const handleOnBlur = (countryValue: string) => {
        if (countryValue) {
            setFloatLabel(true);
        } else {
            setFloatLabel(false);
        }
    };

    const handleOnChange = (country: FormSelectChoice) => {
        handleOnBlur(country?.value as string);
        onChange(country);
    };

    return (
        <div className={`sid-field ${inputId} ${focus ? 'sid-focused' : ''}`}>
            <div className="sid-l-space-top-md" />
            <FieldLabel
                text={<FormattedHTMLMessage id="country" defaultMessage="Country" />}
                htmlForLabel={inputId}
                id={`${inputId}-label`}
                displayClasses={`${placeholder && 'sid-h-screen-reader-only'} ${floatLabel ? 'sid-field__label--floating' : ''}`}
                isRequired={isRequired}
            />

            <InputSelectComponent
                fieldId="country"
                inputId={inputId}
                fieldLabelId={`${inputId}-label`}
                isErrored={isErrored}
                options={options}
                onChange={(country: FormSelectChoice) => handleOnChange(country)}
                onBlur={(event: React.FocusEvent<HTMLInputElement>) => {
                    handleOnBlur(event.target.value);
                    setFocus(false);
                }}
                onFocus={() => {
                    setFloatLabel(true);
                    setFocus(true);
                }}
                onKeyDown={onKeyDown}
                placeholder={
                    placeholder
          || intl.formatMessage({ id: 'countryPlaceholder', defaultMessage: 'Country*' })
                }
                value={
                    value
                        ? {
                            value: value.value,
                            label: intl.formatMessage({
                                id: `countries.${value.value}`,
                                defaultMessage: value.label || value.value,
                            }),
                        }
                        : undefined
                }
                isRequired
            />

            {isErrored ? (
                <div className="sid-field-error">
                    <FormattedHTMLMessage id="errorId.invalidCountry" defaultMessage="Invalid country" />
                </div>
            ) : null}
        </div>
    );
};

export const CountryComponent = injectIntl(Country);
